//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import theme from '@theme/theme';

export const PinterestAudienceStatBubbleTitles = {
  CHANGE_IN_FOLLOWERS: 'Change in Followers',
  PROFILE_VIEWS: 'Profile Views',
  TOTAL_AUDIENCE: 'Total Audience',
  TOTAL_ENGAGED_AUDIENCE: 'Total Engaged Audience',
};

export const PinterestAudienceTooltips = {
  AUDIENCE_GENDER:
    'The gender distribution of your audience in the last 30 days. Only available from people who have chosen to provide it.',
  AUDIENCE_AGE:
    'The age distribution of your audience in the last 30 days. Only available for people who have provided it.',
  CHANGE_IN_FOLLOWERS:
    'Net change in followers includes followers gained and lost in the last 30 days.',
  DEVICE_BREAKDOWN: 'The devices used by your audience in the last 30 days.',
  FOLLOWER_COUNT:
    'The total number and change in followers for the date range selected.',
  LOCATION_DISTRIBUTION:
    'The top locations for your audience in the last 30 days.',
  PROFILE_VIEWS:
    'The number of unique views your pins received in the last 30 days.',
  PROFILE_VIEWS_INVALID: 'This metric is only available for business accounts.',
  PROFILE_VIEWS_10M:
    'If the number of unique views across all your pins exceeds 10M, Pinterest reports this metric as 10M+.',
  TOTAL_AUDIENCE:
    'Your total audience includes all users who have seen or engaged with any of your Pins in the last 30 days.',
  TOTAL_ENGAGED_AUDIENCE:
    'Your engaged audience includes all users who have engaged with any of your Pins in the last 30 days.',
};

export enum PinterestGender {
  Male = 'M',
  Female = 'F',
  Unspecified = 'U',
}

export const getGenderColor = (gender: PinterestGender) => {
  switch (gender) {
    case PinterestGender.Male:
      return theme.colors.blue3;
    case PinterestGender.Female:
      return theme.colors.blue2;
    case PinterestGender.Unspecified:
      return theme.colors.blue1;
  }
};

export enum PinterestAudienceByLocationOptions {
  topMetros = 'TOP_METROS',
  topCountries = 'TOP_COUNTRIES',
}

export const LOCATION_DROPDOWN_OPTIONS = [
  {
    label: 'Top Metros',
    value: PinterestAudienceByLocationOptions.topMetros,
  },
  {
    label: 'Top Countries',
    value: PinterestAudienceByLocationOptions.topCountries,
  },
];

export const DISCLAIMER =
  'Due to Pinterest API limitations, top-level metrics are only available for the last 30 days.';
